<template>
  <div class="quiz-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>

    <div class="quiz-integral">
      <h4 class="mt-3">
        Quiz {{quiz.name}}
      </h4>
      <div class="bg-white p-4 mt-3">
        <div class="text-left text-md-right p-0 p-md-3">
          <p class="py-3">
            Waktu penyelesaian quiz
          </p>
          <p class="quiz-integral__when d-inline p-2 my-2">
            {{formatDate(quiz_result.created_at)}}
          </p>
        </div>

        <img
          class="quiz-integral__img mt-5 mt-md-0"
          src="/img/quiz/selamat.png"
        />
        <h2 class="text-center mt-3">
          Selamat, nilaimu {{quiz_result.score ? Math.round(quiz_result.score) : '0'}}
        </h2>
        <p class="text-center quiz-integral__p m-auto">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
        </p>

        <quiz-summary class="mt-4" :result="quiz_result"> </quiz-summary>

        <div class="ajustify-center mt-4 pb-5">
          <my-button class="m-2 px-5 btn-font sm-w-100" type="fill-blue" @click="restartQuiz">
            <fa-icon class="mr-1" icon="redo-alt"></fa-icon>
            Ulangi Quiz
          </my-button>
          <my-button class="m-2 px-5 btn-font sm-w-100"  @click="quizAnswer">
            <fa-icon class="mr-1" icon="search"></fa-icon>
            Kunci Jawaban
          </my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyButton from "../../components/MyButton.vue";
import QuizSummary from "../../components/QuizSummary";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  components: { MyButton },
  data: () => ({
    pagination: [
      {
        text: "SMA",
        url: "#"
      },
      {
        text: "Pelajaran SMA Kelas 12",
        url: "#"
      },
      {
        text: "KTSP",
        url: "#"
      },
      {
        text: "Matematika SMA Kelas 12",
        url: "#"
      },
      {
        text: "KTSP 2006",
        url: "#"
      },
      {
        text: "Bab 1 - Integral",
        url: "#"
      }
    ]
  }),
  mounted() {
    if(!this.quiz_result.quiz_id || (this.quiz_result.quiz_id != this.$route.params.quiz)) {
      this.restartQuiz();
    }
  },
  computed: {
    ...mapGetters({
      quiz_result: types.QUIZ_RESULT,
      quiz: types.QUIZ, 
      section: types.SECTION
    })
  },
  components: {
    MyButton,
    QuizSummary
  },
  methods: {
    restartQuiz() {
      this.$router.push('/class/'+this.section.id+"/quiz/"+this.$route.params.quiz)
    },
    quizAnswer() {
      this.$router.push('/class/'+this.section.id+"/quiz/"+this.$route.params.quiz+"/answer")
    },
    formatDate(strDate) {
      var monthName = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      var date = new Date(strDate);
      var yyyy = date.getFullYear();
      var mm = monthName[date.getMonth()];
      var dd = String(date.getDate()).padStart(2, "0");
      var hh = String(date.getHours()).padStart(2, "0");
      var ii = String(date.getMinutes()).padStart(2, "0");
      var ss = String(date.getSeconds()).padStart(2, "0");

      date = dd + " " + mm + " " + yyyy + " " + hh + ":" + ii + ":" + ss;

      return date;
    }
  }
};
</script>
<style>
.quiz-integral {
  padding: 22px;
  padding-top: 0;
}

.quiz-integral__p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.86;
  color: #000000;
  max-width: 477px;
}

.quiz-integral__img {
  width: 85px;
  height: 83.1px;
  margin: auto;
  display: block;
}

.quiz-integral__when {
  color: #ff4e4b;
  background-color: #feedec;
}

.btn-font {
  font-size: 14px;
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .quiz-integral {
    padding: 15px;
  }
}
</style>
